@if (internalError) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong>{{ internalError }}</strong>
      </p>
    </div>
  </div>
}

@if (isV2) {
  <!-- Séquençage V2 — Visuel accordion harmonisé avec PackBuilderComponent.
       Sections par pack (Réglementaire / Adéquation / BS), chaque doc se déplie
       pour afficher le PDF preview inline (lazy-load). -->
  @if (loading) {
    <div class="loader">
      <pr-loader></pr-loader>
      <p class="loader-documents-message">{{ loadingMessage }}</p>
    </div>
  } @else if (v2Sections.length === 0) {
    <info>Aucun document à valider pour cette souscription.</info>
  } @else {
    @for (section of v2Sections; track section.packType) {
      <section class="pack-section">
        <h3 class="pack-title">{{ section.title }}</h3>
        @for (row of section.rows; track row.packDocumentId) {
          <article class="doc-row" [class.expanded]="row.expanded">
            <div class="doc-header" (click)="onV2DocClick(row)">
              <span class="doc-toggle" aria-hidden="true">{{
                row.expanded ? '−' : '+'
              }}</span>
              <span class="doc-label">{{ row.label }}</span>
              @if (!row.gedDocumentId) {
                <span class="badge badge-pending"
                  >PDF disponible après envoi</span
                >
              }
              @if (row.gedDocumentId) {
                <button
                  type="button"
                  class="doc-download"
                  [matTooltip]="
                    row.pdfError
                      ? 'Échec du téléchargement — cliquer pour réessayer'
                      : 'Télécharger le PDF'
                  "
                  aria-label="Télécharger le PDF"
                  [class.error]="row.pdfError"
                  [disabled]="row.downloading"
                  (click)="$event.stopPropagation(); onV2DownloadClick(row)"
                >
                  @if (row.downloading) {
                    <mat-icon class="spin">autorenew</mat-icon>
                  } @else {
                    <mat-icon>download</mat-icon>
                  }
                </button>
              }
            </div>
            @if (row.expanded) {
              <div class="doc-body">
                @if (row.pdfSafeUrl) {
                  <iframe
                    [src]="row.pdfSafeUrl"
                    width="100%"
                    height="600"
                    frameborder="0"
                  ></iframe>
                } @else if (row.loadingPdf) {
                  <pr-loader></pr-loader>
                } @else if (!row.gedDocumentId) {
                  <div class="doc-meta">
                    Ce document sera généré et signé au moment de l'envoi (Pack
                    Bulletins de souscription).
                  </div>
                } @else if (row.pdfError) {
                  <div class="doc-meta error">
                    Erreur lors du chargement du PDF.
                  </div>
                }
              </div>
            }
          </article>
        }
      </section>
    }
  }
} @else {
  @if (!loading) {
    <div style="margin-top: 1rem">
      <tabs [tabs]="tabs" (tabClicked)="onTabClicked($event)"></tabs>
    </div>
  }
  <div style="max-height: none; margin-top: 1rem; position: relative">
    @if (loading) {
      <div>
        <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
        <div class="progress">
          <div class="progress-bar" [style.width.%]="progress"></div>
        </div>
        <p class="loader-documents-message">{{ loadingMessage }}</p>
      </div>
    }

    @if (safeUrl && !loading) {
      <iframe [src]="safeUrl" width="100%" height="700" frameborder="0">
      </iframe>
    }
  </div>
}

@if (!loading) {
  <form-footer
    (prev)="prev()"
    (next)="next()"
    [disabledSkip]="true"
  ></form-footer>
}
